export const blockIconsAudioandvideoFastForward = (
	<span className='material-symbols-outlined'>fast_forward</span>
);
